import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const narashiHoikuKikan: BlogMetaData = {
  title: '慣らし保育の期間はどれくらい？1〜2週間のスケジュール例と乗り切るコツ',
  description:
    '慣らし保育の期間はいつからいつまで？1〜2週間の一般的なスケジュール例、仕事復帰との調整方法、子どもが泣いて不安なときの向き合い方をモンテッソーリ園の視点で解説します。',
  thumbnailUrl: '/img/blog-narashi-hoiku-kikan.webp',
  filePath: buildBlogFilePath('narashi-hoiku-kikan'),
  category: BLOG_CATEGORY.NURSERY,
};
